import { useGetTotalApiUsageQuery } from "gql/generated.graphql";
import { API_PLUGIN_USER_LINK } from "../constants/constants";
import {
  ApiChartFilter,
  DatePeriodTypesEnum,
  getPeriodRangeByPeriodType,
} from "dash-ui";

export const generateApiReferralLink = (value: string) => {
  return value ? `${API_PLUGIN_USER_LINK}${value}` : "";
};

export const totalApiUsageFetchFunction =
  ({ type, appId, getCompanyClients, getCompanyTotal }: ApiChartFilter) =>
  (dateRange: any) => {
    const { data, loading } = useGetTotalApiUsageQuery({
      variables: {
        pagination: {
          allowLimit: false,
        },
        filter: {
          range: dateRange
            ? {
                startDate: dateRange?.startDate,
                endDate: dateRange?.endDate,
              }
            : getPeriodRangeByPeriodType(DatePeriodTypesEnum.CURRENT_WEEK),
          type,
          appId,
          getCompanyClients,
          getCompanyTotal,
        },
      },
    });

    return {
      data: data?.getTotalApiUsage?.collection || [],
      loading,
    };
  };
